import * as React from 'react';
import { useOutletContext } from 'react-router-dom-v5-compat';

import type { JobPreviewOutletContext } from '../types';
import JobMaterialsTable from './JobMaterialsTable';
import MaterialJobRatesTable from './JobRatesTable';

const Materials: React.FC = () => {
	const { jobId } = useOutletContext<JobPreviewOutletContext>();

	return (
		<>
			<MaterialJobRatesTable jobId={jobId} />
			<JobMaterialsTable jobId={jobId} />
		</>
	);
};

export default Materials;
